/** Unicode BOM character; UTF-8 encoding is EF BB BF — helps Excel detect UTF-8 in CSV. */
export const CSV_UTF8_BOM = '\uFEFF';

export const CSV_BLOB_TYPE = 'text/csv;charset=utf-8';
